module.exports = __webpack_public_path__ + "static/media/3.3cee8073.jpg";